import {Pipe, PipeTransform} from '@angular/core';
import {SortTypePlayer} from '../app.config';

@Pipe({
    name: 'orderby',
    pure: false
})
export class OrderbyPipe implements PipeTransform {

    transform(array: any, orderBy: string, asc = true, isXiSort: boolean) {
        if (!orderBy || orderBy.trim() === '') {
            return array;
        }
        const array1 = array.filter((o: any) => {
            return o.IsXi === true;
        });
        const array2 = array.filter((o: any) => {
            return o.IsXi === false;
        });
        if (array) {
            if (asc) {
                if (isXiSort) {
                    const value1 = Array.from(array1).sort((item1: any, item2: any) => {
                        if (typeof item2[orderBy] === 'boolean' || item1[orderBy] === 'boolean') {
                            return this.orderByComparator(item2[orderBy] ? 1 : 0, item1[orderBy] ? 1 : 0);
                        } else {
                            return this.orderByComparator(item1[orderBy], item2[orderBy]);
                        }
                    });
                    const value2 = Array.from(array2).sort((item1: any, item2: any) => {
                        if (typeof item2[orderBy] === 'boolean' || item1[orderBy] === 'boolean') {
                            return this.orderByComparator(item2[orderBy] ? 1 : 0, item1[orderBy] ? 1 : 0);
                        } else {
                            return this.orderByComparator(item1[orderBy], item2[orderBy]);
                        }
                    });
                    return value1.concat(value2);
                } else {
                    return Array.from(array).sort((item1: any, item2: any) => {
                        if (typeof item2[orderBy] === 'boolean' || item1[orderBy] === 'boolean') {
                            return this.orderByComparator(item2[orderBy] ? 1 : 0, item1[orderBy] ? 1 : 0);
                        } else {
                            return this.orderByComparator(item1[orderBy], item2[orderBy]);
                        }
                    });
                }
            } else {
                if (isXiSort) {
                    const value1 = Array.from(array1).sort((item1: any, item2: any) => {
                        if (typeof item2[orderBy] === 'boolean' || item1[orderBy] === 'boolean') {
                            return this.orderByComparator(item2[orderBy] ? 1 : 0, item1[orderBy] ? 1 : 0);
                        } else {
                            return this.orderByComparator(item2[orderBy], item1[orderBy]);
                        }
                    });
                    const value2 = Array.from(array2).sort((item1: any, item2: any) => {
                        if (typeof item2[orderBy] === 'boolean' || item1[orderBy] === 'boolean') {
                            return this.orderByComparator(item2[orderBy] ? 1 : 0, item1[orderBy] ? 1 : 0);
                        } else {
                            return this.orderByComparator(item2[orderBy], item1[orderBy]);
                        }
                    });
                    return value1.concat(value2);
                } else {
                    return Array.from(array).sort((item1: any, item2: any) => {
                        if (typeof item2[orderBy] === 'boolean' || item1[orderBy] === 'boolean') {
                            return this.orderByComparator(item2[orderBy] ? 1 : 0, item1[orderBy] ? 1 : 0);
                        } else {
                            return this.orderByComparator(item2[orderBy], item1[orderBy]);
                        }
                    });
                }
            }
        }
    }

    orderByComparator(a: any, b: any): number {
        if ((isNaN(parseFloat(a)) || !isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))) {
            if (a.toLowerCase() < b.toLowerCase()) {
                return -1;
            }
            if (a.toLowerCase() > b.toLowerCase()) {
                return 1;
            }
        } else {
            if (parseFloat(a) < parseFloat(b)) {
                return -1;
            }
            if (parseFloat(a) > parseFloat(b)) {
                return 1;
            }
        }

        return 0;
    }
}
